import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { MRQDetailsInputs } from "./utils";
import { useBOMDashboardContext } from "../../../../BOMDashboard.context";
import LabelledBox from "../../../../../../../../../../components/widgets/LabelledBox";
import SelectDoc from "./SelectDoc";
import { secondAxios } from "../../../../../../../../../../api/axios";
import { DrawingBomContext } from "../../../DrawingBomContext";
import { useMcsContext } from "../../../../../MCS.context";
import { getMrqs } from "../../../../api";

export default function MrqForm() {
  const { plant, setPlant } = useMcsContext();
  const { mrqDetails, onMrqDetailsChange, selectedMrqDoc, setSelectedMrqDoc } =
    React.useContext(DrawingBomContext);

  const [plantDocs, setPlantDocs] = React.useState([]);

  const [newDoc, setNewDoc] = React.useState("");
  const [selectedMrqNumber, setSelectedMrqNumber] = React.useState("");

  console.log({ plant });
  React.useEffect(() => {
    if (mrqDetails?.mrqNumber) {
      setSelectedMrqNumber(mrqDetails.mrqNumber);
    }
  }, [mrqDetails?.mrqNumber]);
  React.useEffect(() => {
    async function getAllDocumentLists() {
      try {
        const res = await secondAxios.get(`documents/${plant.id}/type/mrq`);
        if (res?.data) {
          setPlantDocs(res.data);
        }
      } catch (error) {
        console.log({ error });
      }
    }

    const fetchMrqList = async () => {
      await getMrqs({ plantId: plant.id }).then((res) => {
        setPlant({ ...plant, mrqs: res });
      });
    };

    fetchMrqList();

    getAllDocumentLists();
  }, []);

  const onChangeNewDoc = (e) => {
    setSelectedMrqDoc("");
    setNewDoc(e.target.value);
  };

  const onMrqNumberChange = (e) => {
    const value = e.target.value;
    setSelectedMrqNumber(value);
    onMrqDetailsChange({ target: { name: "mrqNumber", value } });

    // onMrqDetailsChange({ target: { name: "rev", value: "" } });
  };

  const onRevChange = (e) => {
    onMrqDetailsChange({ target: { name: "rev", value: e.target.value } });
  };

  const uniqueMrqNumbers = [
    ...new Set(
      plant?.mrqs
        ?.filter((m) => !m.mrqMaterials?.length)
        .map((m) => m.mrqNumber) || [],
    ),
  ];

  console.log("uniqueMrqNumbers", uniqueMrqNumbers, plant?.mrqs);
  const availableRevs =
    plant?.mrqs
      ?.filter((m) => m.mrqNumber === selectedMrqNumber)
      .map((m) => m.rev) || [];
  // console.log("selectedMrqDoc: ", selectedMrqDoc);
  const onSelectExistedDoc = (event) => {
    setNewDoc("");
    setSelectedMrqDoc(event.target.value);
  };

  const onSaveNewDoc = async () => {
    try {
      const res = await secondAxios.post(`documents/${plant.id}`, {
        type: "mrq",
        title: newDoc,
      });
      if (res?.data) {
        setPlantDocs([...plantDocs, res.data]);
        setNewDoc("");
        setSelectedMrqDoc(res.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  console.log("mrqDetaaaails", mrqDetails);
  return (
    <Box>
      <LabelledBox label="MRQ Details">
        <Grid
          container
          // spacing={2}
          columns={{ xs: 6.8 }}
          sx={{ width: "1050px" }}
        >
          {MRQDetailsInputs.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={item.grid} sx={{ p: 0.5 }}>
                <Typography>{item.label}</Typography>
              </Grid>
              <Grid item xs={item.label === "Title" ? 2.6 : 1} sx={{ p: 0.5 }}>
                {item.field === "mrqNumber" ? (
                  <FormControl fullWidth size="small">
                    <Select
                      value={mrqDetails?.mrqNumber || ""}
                      onChange={onMrqNumberChange}
                      sx={{
                        "& .MuiSelect-select": {
                          py: 0.5,
                        },
                      }}
                    >
                      {uniqueMrqNumbers.map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : item.field === "rev" ? (
                  <FormControl fullWidth size="small">
                    <Select
                      value={mrqDetails?.rev || ""}
                      onChange={onRevChange}
                      disabled={!selectedMrqNumber}
                      sx={{
                        "& .MuiSelect-select": {
                          py: 0.5,
                        },
                      }}
                    >
                      {availableRevs.map((rev) => (
                        <MenuItem key={rev} value={rev}>
                          {rev}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    hiddenLabel
                    size="small"
                    fullWidth
                    name={item.field}
                    type={item.field === "mrqDate" ? "date" : "text"}
                    autoComplete="off"
                    disabled={["wbs", "plantName"].includes(item.field)}
                    value={
                      item.field === "plantName"
                        ? plant.name
                        : mrqDetails?.[item.field] || ""
                    }
                    inputProps={{ sx: { padding: "2px", pl: "5px" } }}
                    onChange={onMrqDetailsChange}
                  />
                )}
              </Grid>
            </React.Fragment>
          ))}

          {/* <Grid item xs={0.73} sx={{ p: 0.5, py: 2 }}>
            Document #
          </Grid>
          {plantDocs[0] && (
            <Grid item xs={2} sx={{ p: 1, px: 0 }}>
              <SelectDoc
                onSelectExistedDoc={onSelectExistedDoc}
                selectedMrqDoc={selectedMrqDoc}
                plantDocs={plantDocs}
                setPlantDocs={setPlantDocs}
              />
            </Grid>
          )}

          <Grid item xs={2} sx={{ p: 1, px: 0 }}>
            <TextField
              fullWidth
              label="Or Create New Document #"
              variant="outlined"
              size="small"
              sx={{ ml: 1 }}
              value={newDoc}
              onChange={onChangeNewDoc}
            />{" "}
          </Grid>
          {newDoc && (
            <Grid item xs={1} sx={{ ml: 2, p: 1, px: 0 }}>
              <Button variant="contained" onClick={onSaveNewDoc}>
                Add Document
              </Button>
            </Grid>
          )} */}
        </Grid>
      </LabelledBox>
    </Box>
  );
}
